import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, BreadcrumbItem } from "reactstrap";

interface BreadcrumbProps {
  breadcrumbItem: string;
  title: string;
}

const Breadcrumb = ({ breadcrumbItem, title }: BreadcrumbProps) => {
  return (
    <Row>
      <Col xs="12">
        <div
          className="page-title-box d-sm-flex align-items-start justify-content-start flex-column"
          style={{ paddingBottom: 0 }}
        >
          <h4 className="mb-0 font-size-18">{breadcrumbItem}</h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0 mt-1 ">
              <BreadcrumbItem style={{ fontSize: 12 }}>
                <Link to="#" className="text-muted">
                  {title}
                </Link>
              </BreadcrumbItem>
              <BreadcrumbItem active style={{ fontSize: 12 }}>
                <Link to="#" className="text-muted">
                  {breadcrumbItem}
                </Link>
              </BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Breadcrumb;
